<template>
  <div >
    <div class="box-title">
      {{ $t('History.title') }}
    </div>
    <div class="trend-row">
      <el-date-picker
        v-model="dateRange"
        size="small"
        class="filter-item"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="開始日期"
        end-placeholder="結束日期">
      </el-date-picker>
      <el-radio-group
        v-model="selectedSampling"
        size="small"
        type="primary" >
        <el-radio-button
          v-for="(value, key) in samplingOptions"
          :key="key"
          :label="key"
          plain>
          {{ $t('History.'+key) }}
        </el-radio-button>
      </el-radio-group>
    </div>

    <el-button
      class="bt-draw"
      size="small"
      type="primary"
      @click="searchBtnClick()"
    >
      {{ $t('History.plot') }}
    </el-button>

    <p v-if="!chartDataExist" class="font-b font-df"> {{ $t('History.empty') }} </p>

    <div style="width:100%; height:400px">
      <v-chart
        :option="historyChart"
        :theme="chartsTheme"
        :update-options="{ notMerge: true}"
        :loading="chartLoading"
        style="width: 100%; height:100%"
        autoresize />
    </div>
  </div>
</template>

<script>
import { mixins } from '@/views/common/mixins.js'
import moment from 'moment-timezone'

export default {
  // 歷史曲線圖
  name: 'History',
  mixins: [mixins],
  props: {
    shareUVTU: {
      type: String,
      default: 'hour'
    }
  },
  data() {
    return {
      dateRange: [this.parseDateTime(new Date().toISOString()), this.parseDateTime(new Date().toISOString())],
      query: {
        start: this.parseDateTime(new Date().toISOString()),
        end: this.parseDateTime(new Date().toISOString()),
        // sampling: 'none'
      },
      chartDataExist: false, // 是否有圖表資料
      xAxisData: [], // x軸 日期時間
      flowLine: [],
      lastSampling: 'day',

      // sampling 選項
      samplingOptions: {
        'day': '日',
        'week': '週',
        'month': '月',
        'year': '年',
        'customDate': '日期',
      },
      // 選擇的 sampling
      selectedSampling: 'customDate',
      chartLoading: false,
      showControl: {
        customDate: true,
        day: false,
        week: false,
        month: false,
        year: false
      }
    };
  },
  watch: {
    dateRange: function(val) {
      if (val) {
        this.query.start = val[0]
        this.query.end = val[1]
      } else {
        this.query.start = undefined
        this.query.end = undefined
      }
    },
    selectedSampling: function(val) {
      if (val == 'customDate') { // 不選擇 sampling
        this.query.sampling = undefined
      } else {
        this.query.sampling = val
      }
      this.getHistoryChart()
    }
  },
  created() {
    this.getHistoryChart()
  },
  mounted() {
    // 依照使用者設定調整日期UI顯示
    this.setSamplingDisplay()
  },
  computed: {
    currentWaterId() {
      return JSON.parse(localStorage.getItem('currentProfile')).waterId
    },

    historyChart() {
      let _this = this
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            const tooltipData = params[0].data[2]
            if (tooltipData && tooltipData.isVisible) {
              return `<b>${_this.$t('History.logTime')}:</b> ${tooltipData.recordedOn? tooltipData.recordedOn.substring(0,19): ''} <br/>
                      <p style="color: #4791DC; margin: 0"><b>${_this.$t('History.instantFlow')}:</b> ${tooltipData.value != undefined ? tooltipData.value : ''} (m³/h) </p>
                      <b>${_this.$t('History.totalizerLog')}:</b> ${tooltipData.volume? tooltipData.volume: ''} (m3) <br/>`
            } else {
              return null
            }
          },
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          min: this.$moment(_this.query.start).startOf('day').format("YYYY-MM-DD HH:mm"),
          max: this.$moment(_this.query.end).add(1, 'days').add(1, 'minutes').format("YYYY-MM-DD HH:mm"),
          // interval: 3600 * 1000,
          // minInterval: 1 * 60 * 60 * 1000,
          // maxInterval: 3 * 60 * 60 * 1000,
          axisLabel: {
            margin: 10,  // 調整標籤與軸線之間的距離
            rotate: 30, // 設置傾斜角度，可以是正數或負數，根據需要進行調整
            formatter: function (value) {
              return moment(value).format('YYYY-MM-DD HH:mm')
            }
          } 
        },
        yAxis: {
          type: 'value',
          name: this.$t('History.flow')
        },
        grid: {
          bottom: '35%'
        },
        dataZoom: [
          {
            type: 'slider',
            start: 0,
            end: 100
          },
          {
            type: 'inside',
            start: 10,
            end: 60
          }
        ],
        series: [
          {
            data: _this.flowLine,
            type: 'line',
            name: '瞬間流量',
            lineStyle: {
              color: '#4791DC'
            },
            symbol: 'none',
            connectNulls: false
          }
        ]
      }
      return option
    }
  },
  methods: {
    searchBtnClick() {
      this.getHistoryChart()
    },
    // 趨勢圖圖表
    async getHistoryChart() {
      if (this.currentWaterId) {
        let flowList = []
        this.chartLoading = true

        if (this.lastSampling != this.query.sampling) {
          this.query.start = this.parseDateTime(new Date().toISOString())
          this.query.end = this.parseDateTime(new Date().toISOString())
        }

        await this.axios.get('/api/report/profile/' +  this.currentWaterId + '/rawdata/period', {params: this.query}).then(res => {
          // console.log('res.data', res.data)
          if (res) {
            let response = res.data
            this.lastSampling = this.query.sampling
            
            if (response.start && response.end) {
              // 回顯 不同 sampling 校正回的日期
              this.dateRange = [ response.start, response.end]
            }

            if (response.rawdata.length > 0) {
              let data = response.rawdata
              this.chartDataExist = true // 圖表資料存在

              data.forEach(element => {
                let formatedTime = this.parseDateTimeToHHMMSS(element.recordedOn) // 紀錄日期格式化
                // 瞬間流量
                flowList.push([
                  new Date(formatedTime),
                  element.visible ? element.flow: null,
                  {
                    recordedOn: formatedTime,
                    volume: element.volumeAdjusted != null ? element.volumeAdjusted.toFixed(2): (element.volume != undefined ? element.volume.toFixed(2): ''), // 若有人工調整指針 則呈現人工調整後的值
                    flow: element.flow == undefined ? '' : element.flow.toFixed(3),
                    // average: element.average,
                    // standardDeviation: element.standardDeviation,
                    value: element.flow == undefined ? undefined : element.flow.toFixed(3), // value 決定線的值, 如 visible = true 才顯示
                    isVisible: element.visible 
                  } 
                ])

              });

              this.chartLoading = false
            } else {
              this.chartDataExist = false // 無圖表資料
            }
          }
          
        }).catch(() => {
          this.$message({ message: this.$t('Warning.empty'), type: 'warning' })
          this.chartLoading = false
        })
        .finally(() => {
          this.chartLoading = false
        })

        if (this.chartDataExist) { // 圖表資料存在
          /*
          // this.xAxisData = datetime // 圖表x軸
          // this.xAxisData = 

          const startDate = this.$moment(this.query.start);
          const endDate = this.$moment(this.query.end).add(1, 'days').startOf('day'); // 加一天

          const xAxisData = [];
          const currentDate = startDate.clone();
          
          while (currentDate.isBefore(endDate)) {
            xAxisData.push(currentDate.format('YYYY-MM-DD HH:mm'));
            currentDate.add(1, 'hours');
          }

          // 將 endDate + 1 天的 00:00
          xAxisData.push(endDate.format('YYYY-MM-DD HH:mm'));
            
          this.xAxisData = xAxisData
          // console.log('xAxisData', this.xAxisData)
          */
          this.flowLine = this.completeDisconnectedTime(flowList)
        }
      }
    },
    // 在斷開的時間補上Null資料以實現chart line斷開
    completeDisconnectedTime(flowList) {
      const disconnectedPeriod = 60 * 60 * 1000
      const resultArray = [];
      for (let i = 0; i < flowList.length; i++) {
        resultArray.push(flowList[i]);

        // 檢查相鄰的時間點之間是否存在間隔
        if (i < flowList.length - 1) {
          const nextTime = flowList[i + 1][0]
          const currentTime = flowList[i][0]
          const timeDiff = moment(nextTime).diff(currentTime)
          if (timeDiff > disconnectedPeriod) {
            resultArray.push([moment(currentTime).add(1, 'hours').toDate(), null]);
          }
        }
      }

      return resultArray
    },
    setSamplingDisplay() {
      if (this.shareUVTU === 'hour' || this.shareUVTU === 'day') {
        this.showControl.day = true
        this.showControl.week = true
        this.showControl.month = true
        this.showControl.year = true
      } else if (this.shareUVTU === 'week') {
        this.showControl.week = true
        this.showControl.month = true
        this.showControl.year = true
      } else if (this.shareUVTU === 'month') {
        this.showControl.month = true
        this.showControl.year = true
      } else if (this.shareUVTU === 'year') {
        this.showControl.year = true
      }
      if(!this.shareUVTU) {
        this.selectedSampling = 'customDate'
      } else if(this.shareUVTU === 'hour') {
        this.selectedSampling = 'day'
      }else {
        this.selectedSampling = this.shareUVTU
      }
    }

  }
}
</script>
